import { HTML_ATTRIBUTE_INLINE, HTML_TAG_CONSENT_SCRIPT, HTML_ATTRIBUTE_TRANSFORM_WRAPPER } from ".";
import { putHtmlCodeToDom } from "..";
/**
 * Put an prepared inline script to the DOM.
 */

function putScriptInlineToDom(node) {
  // Get the inline script itself
  var inlineScript = node.getAttribute(HTML_ATTRIBUTE_INLINE);
  node.removeAttribute(HTML_ATTRIBUTE_INLINE); // Transform the tag to the `script`
  // We need to make such a hacky way because regex does not work and `outerHTML` has also some issues...

  var inlineScriptHtml = node.outerHTML.substr(HTML_TAG_CONSENT_SCRIPT.length + 1);
  inlineScriptHtml = inlineScriptHtml.substr(0, inlineScriptHtml.length - HTML_TAG_CONSENT_SCRIPT.length - 3);
  inlineScriptHtml = "<script".concat(inlineScriptHtml).concat(inlineScript, "</script>"); // Check, if there is a transform wrapper as we know from usual (non-inline) scripts (e.g. transformToOriginalContentBlockerAttribute)

  var previousElementSibling = node.previousElementSibling;
  return putHtmlCodeToDom(inlineScriptHtml, {}, previousElementSibling !== null && previousElementSibling !== void 0 && previousElementSibling.hasAttribute(HTML_ATTRIBUTE_TRANSFORM_WRAPPER) ? previousElementSibling : node);
}

export { putScriptInlineToDom };